const e=async(e,t,n,r,i)=>{let{data:a}=await e.get(`/webhooks/${t}/${n}/${r}/subscriptions`,{params:i});return a};export{e as getWebhookSubscriptions};
//# sourceMappingURL=get-subscriptions.mjs.map